import { PageShell } from '@/components/primitives/PageShell';
import { PageHeader } from '@/components/primitives/PageHeader';
// Legacy MUI page rendered inside the AppShell — passes `embedded` so the
// in-component hero is hidden (PageHeader provides the title instead).
// eslint-disable-next-line @typescript-eslint/no-explicit-any
import ForecastPageRaw from './ForecastPage';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ForecastPage = ForecastPageRaw as any;

/**
 * Forecast page wrapper for the authenticated AppShell.
 * Renders the existing legacy ForecastPage body without its hero banner.
 */
export default function AuthenticatedForecastPage() {
  return (
    <PageShell>
      <PageHeader
        title="Forecast"
        subtitle="7-day fire danger forecast"
      />
      <ForecastPage embedded />
    </PageShell>
  );
}
